/* eslint-disable react/prop-types */
import React from 'react';
import './Button.scss';
/**
 * Action
 * btnId
 * btnText
 * disableBtn
 */
const Button = ({btnText, btnType='button', Action, btnDisabled, btnId, cb_btn_class}) => (
  <button type={btnType} disabled={btnDisabled} onClick={Action} data-testid={btnId} id={btnId} className={`cb-btn ${cb_btn_class}`}>
    <p>
      {btnText}
    </p>
  </button>
);

export default Button;